<template>
  <div class="empty-state">
    <img class="image" :src="imgSrc" />
    <p>{{ emptyMessage }}</p>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  name: 'EmptyState',
  props: {
    imgSrc: {
      type: String,
      default: '/assets/img/_Moon.png',
    },
    message: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const { t } = useI18n();
    const emptyMessage = computed(
      () => props.message || t('no-results-found-we-even-tried-looking-in-space').toString()
    );

    return { emptyMessage };
  },
});
</script>

<style lang="scss" scoped>
.empty-state {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: var(--spacing-75);

  .image {
    max-width: 50%;
    object-fit: contain;
    margin-bottom: var(--spacing-100);
  }
}
</style>
